module.exports = {
    Form: require('./Form').default,
    Navbar: require('./Navbar').default,
    Menu: require('./Menu').default,
    Rating: require('./Rating').default
}



// WEBPACK FOOTER //
// ./src/index.js